import { Icon } from '@eventbrite/eds-icon';
import cx from 'classnames';
import React from 'react';
import { BenefitsItem } from '../types';
import { LineSVG } from './LineSVG';

type TimelineProps = {
    items: Array<BenefitsItem>;
    activeIdx: number;
    static?: boolean;
};

export const Timeline: React.FC<TimelineProps> = (props) => {
    const renderItems = () => {
        return props.items.map(({ icon: IconType }, idx) => (
            <React.Fragment key={idx}>
                <div
                    className={cx([
                        'boost-benefits__timeline--item',
                        { active: !props.static && idx <= props.activeIdx },
                    ])}
                >
                    <Icon type={IconType} />
                </div>

                {idx < props.items.length - 1 ? (
                    <div className="boost-benefits__timeline--line">
                        <LineSVG active={idx <= props.activeIdx - 1} />
                    </div>
                ) : null}
            </React.Fragment>
        ));
    };

    return <div className="boost-benefits__timeline">{renderItems()}</div>;
};
